import * as React from "react";
import "../../../assets/scss/components/externalTotp.scss";
import LoginErrMsg from "../generic/loginErrMsg";
import "../../../assets/scss/Login/login/forms/passwordForm.scss";
import "../../../assets/scss/Login/login/generic/loginInput.scss";
import YobInputField from "../generic/yobInputField";
import RadioButton from "../../generic/radioButton";
import InputField from "../../generic/inputField";
import EdButton from "../../generic/edButton";
import { useState } from "react";
import LoginFormBtmTxt from "../generic/loginFormBtmTxt";
import { countDown } from "../../utils/countDown";

export interface ITotpFormProps{
  loginId: string; // login id that was entered by the user in loginIdForm
  securityImgObj?: Array<any>; // security image object that comes from api
  disableForm: boolean; // used to disable/enable form from parent
  errorMsg?: string; // error message that came from api
  onEditLoginId: () => void; // when user clicks on edit icon
  onRemoveError: () => void; // removes the errorMsg
  onSubmit: (pwd: string, accTyp: string, totp:string, loginFlow:string) => void; // function to be called on submit
  autoFocus?: boolean;
  totpSetting: ITotpLoginProps;
  onSwitchLoginFlow:(flow: string) => void; // function to switch to OTP Flow
}
export interface ITotpLoginProps{
  eqEtotpEnabled: boolean;
  coEtotpEnabled: boolean;
  otpFlowWaitTime: number;
}
const EtotpForm: React.FC<ITotpFormProps> = (props) => {
  const [totp, setTotp] = useState("");
  const [timer, setTimer] = React.useState({
    min: 0,
    sec: 30,
  });
  const [etotpEnabled, setEtotpEnabled] = useState(false);
  const [loginFlow, setLoginFlow] = useState("ETOTP");
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [enableSms, setEnableSms] = useState(false);
  const [selectedAcc, setSelectedAcc] = useState<"EQ" | "CO" | undefined>(
    props.securityImgObj ? props.securityImgObj[0] : "EQ"
  );
  
  function onChangeHandler(value: string) {
    setTotp(value);
    if (props.errorMsg) {
      props.onRemoveError();
    }
  }
  React.useEffect(() => {
    if(enableSms){
      let intervalId = setInterval(function () {
        countDown(timer.min, timer.sec, setTimer);
      }, 1000);    
      if (timer.min === 0 && timer.sec === 0) {
        props.onSwitchLoginFlow("OTP");
        clearInterval(intervalId);
      }
      return () => {
        clearInterval(intervalId);
      };
    } 
  });

  // function loginFlowChangeHandler() {
  //   if(selectedAcc == "EQ")
  //     setEtotpEnabled(props.totpSetting.eqEtotpEnabled);
  //   else
  //     setEtotpEnabled(props.totpSetting.coEtotpEnabled);
  // }
  function onSelectAcc(accType: "EQ" | "CO" | undefined) {
    setSelectedAcc(accType);
    setShowPassword(false);
    setPassword("");
    if(accType == "EQ")
      setEtotpEnabled(props.totpSetting.eqEtotpEnabled);
    else
      setEtotpEnabled(props.totpSetting.coEtotpEnabled);
  }
  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if(totp && password)
      props.onSubmit(password, selectedAcc as string, totp, loginFlow);
  }
  React.useEffect(() => {
    if(props.totpSetting.otpFlowWaitTime){
      var totSeconds = props.totpSetting.otpFlowWaitTime;
      var min = Math.floor(totSeconds / 60);
      var sec = Math.floor(totSeconds % 60);
      setTimer({min: min, sec: sec});
    }
    if(selectedAcc == "EQ")
      setEtotpEnabled(props.totpSetting.eqEtotpEnabled);
    else
      setEtotpEnabled(props.totpSetting.coEtotpEnabled);
  }, []);

  React.useEffect(() => {
    if (props.errorMsg) {
      setTotp("");
    }
  }, [props.errorMsg]);

  return (
    <div className="login_form pw_form mg-t30">
        <form onSubmit={handleSubmit} autoComplete="off" className="">
        <label className="inp_lbl mg-b5 ib">Login ID</label>
        <p className="login_id mg-b40">
        {props.loginId}{" "}
        <button
          type="button"
          aria-label="Edit Login ID"
          onClick={props.onEditLoginId}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: "0 4px",
            display: "inline-flex",
            alignItems: "center",
          }}
        >
          <i className="edel-icon-edit icon mg-l5" aria-hidden="true" />
        </button>
        </p>   
        {/* {props.securityImgObj && props.securityImgObj.length > 1 && (
          <div className="same_acc">
            <p className="inp_lbl mg-b5">
              Your current login ID is same in equity & commodity
            </p>
            <p className="inp_lbl mg-b20">Select the account to login</p>
            <ul className="same_acc_radio mg-b40">
              <li className="list_Item">
                <RadioButton
                  list={{
                    value: "EQ",
                    display: "Equity",
                  }}
                  name={"sameAcc"}
                  selected={selectedAcc}
                  onChange={() => onSelectAcc("EQ")}
                />
                <RadioButton
                  list={{
                    value: "CO",
                    display: "Commodity",
                  }}
                  name={"sameAcc"}
                  selected={selectedAcc}
                  onChange={() => onSelectAcc("CO")}
                />
              </li>
            </ul>
          </div>
        )} */}

        <label htmlFor="password-input" className="inp_lbl mg-b5 ib">Password</label>
        <InputField
          defaultValue={password}
          id="password-input"
          type={showPassword ? "text" : "password"}
          onChange={setPassword}
          onBlur={() => {}}
          className="login_inp mg-b40 focus"
          placeholder="Eg:Abc@123"
          autoFocus={props.autoFocus}
          suffix={
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              aria-label={showPassword ? "Hide password" : "Show password"}
              aria-pressed={showPassword}
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                padding: "0 4px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <i
                className={`edel-icon-eye${showPassword ? "-cross" : ""} icon`}
                aria-hidden="true"
              />
            </button>
          }
        />
        
        <div className="login_id font-20 mg-b10 text-center etotpFlow" role="group"
      aria-label="Login method">
          {/* <a className={loginFlow =="TOTP" ? "active":""} onClick={() => {setLoginFlow("TOTP");}}>App Code</a> */}
          <button
            type="button"
            role="tab"
            aria-selected={loginFlow === "ETOTP"}
            className={loginFlow === "ETOTP" ? "active etopbtn" : "etopbtn"}
            onClick={() => setLoginFlow("ETOTP")}
          >
            External TOTP
          </button>
          </div>
          {
            loginFlow === "ETOTP" ? (
              !etotpEnabled ? (
                <div className="text-center" role="status" aria-live="polite"><label className="lh26 font-16 inp_lbl mg-b80 mg-t30">You have not registered for External TOTP login flow. You need to log into the portal using OTP login flow by clicking on (unable to use External TOTP) shown below and register for external TOTP.</label></div>
              ) : (
                <div className="text-center"  role="status" aria-live="polite">
                  <label className="lh26 font-16 inp_lbl mg-b30">Use your authenticator app to <br/> generate a 6 digit TOTP.</label>
                </div>
              )
            ) : (
              <div className="text-center"  role="status" aria-live="polite">
                <label className="lh26 font-16 inp_lbl mg-b30">Open the Nuvama Markets app on your phone and use the displayed App code to login.</label>
              </div>
            )
          }
          {((etotpEnabled && loginFlow =="ETOTP") || loginFlow =="TOTP") && (
            <YobInputField
              autoFocus = {false}
              placeholder=""
              onChange={onChangeHandler}
              type={"text"}
              defaultValue={totp}
              id={"totp-"}
              size={6}
              disabled={props.disableForm || (!etotpEnabled && loginFlow =="ETOTP")}
            />
          )}       
        {props.errorMsg && (
          <LoginErrMsg className="mg-b40">{props.errorMsg}</LoginErrMsg>
        )}
        {((etotpEnabled && loginFlow =="ETOTP") || loginFlow =="TOTP") && (
          <EdButton
            value="Proceed"
            btnTyp="primary"
            className="submit_btn mg-t30 mg-b40"
            disabled={
              props.disableForm || password.length < 3 || totp.length < 6
            }
          />
        )}
        {!enableSms ? 
        (
           <button
              type="button"
              className="blue-txt pd-b20 font-14 hoverPink unable_etopbtn"
              onClick={() => setEnableSms(true)}
              aria-label="Unable to use External TOTP? Click to use SMS OTP instead"
            >
              Unable to use External TOTP?
            </button>
        ):(
          <p
          className="blue-txt pd-b20 font-14"
          aria-live="polite"
          aria-label={`Redirecting in ${String(timer.min).padStart(2, "0")}:${String(timer.sec).padStart(2, "0")}`}
          aria-atomic="true"
        >
          Re-directing in...
          <span aria-hidden="true" className="font-14">
            0{timer.min}:{timer.sec > 9 ? timer.sec : "0" + timer.sec}
          </span>
        </p>        
        )}
        {/* {(timer.min !== 0 || timer.sec !== 0 ) && (
          
         )} */}
        <p className="pd-b15"></p>
      </form>
      <LoginFormBtmTxt/>
    </div>
  );
};

export default EtotpForm;